import { buildListingInquiryMessage } from './listingContactMessage';

export function buildWhatsappClickToChatUrl(
  internationalDigits: string,
  listingCode: string
): string {
  const text = buildListingInquiryMessage(listingCode);
  return `https://wa.me/${internationalDigits}?text=${encodeURIComponent(text)}`;
}
